var exports = {
  "oM": "IndicatorsTab.module__itemsWrapper___QWxIeH",
  "tz": "IndicatorsTab.module__itemTextTertiary___QWxIeH",
  "Bp": "IndicatorsTab.module__avatarGroup___QWxIeH",
  "hD": "IndicatorsTab.module__stacksWrapper___QWxIeH",
  "KE": "IndicatorsTab.module__stackItem___QWxIeH",
  "U3": "IndicatorsTab.module__badgesWrapper___QWxIeH",
};

module.exports = exports;
